<template>
	<svg :style="style" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Frame" clip-path="url(#clip0_3654_44570)">
			<path id="Vector"
				d="M22.4021 18.067C21.4237 16.8849 20.205 16.3233 19.387 16.298C18.8436 16.28 18.1472 16.7925 18.1472 16.7925L16.5678 17.8853C16.5678 17.8853 16.0566 18.4114 15.5187 18.39C14.8694 18.3669 14.1692 17.7941 14.1692 17.7941C14.1692 17.7941 11.9677 16.0861 10.3844 14.1405C8.84052 12.2437 7.9152 10.1121 7.9152 10.1121C7.9152 10.1121 7.72277 9.62942 7.85837 9.2416C8.01779 8.78314 8.50977 8.4081 8.50977 8.4081L10.1719 7.25861C10.1719 7.25861 10.8231 6.86003 10.941 6.33677C10.9444 6.31741 11.1263 5.45623 10.8004 4.50485C10.7041 4.22843 10.4437 3.38733 9.8679 2.70906C9.31336 2.05503 8.44938 1.56306 8.04416 1.3838C7.39956 1.09811 6.58425 1.20754 6.43022 1.225C5.81709 1.29446 5.12501 2.04685 5.12501 2.04685C5.12501 2.04685 3.02481 4.12077 2.48412 6.60372C1.88989 9.32058 3.4916 13.106 6.23858 16.547C8.33193 19.1741 11.1775 21.4163 11.1775 21.4163C11.1775 21.4163 12.0785 22.1682 13.0461 22.7168C13.452 22.9473 15.6931 24.3152 18.9337 23.7883C20.8821 23.4711 22.9147 22.2353 22.9147 22.2353C22.9147 22.2353 23.6688 21.8422 23.7092 21.3696C23.7678 20.692 23.2061 19.0422 22.4021 18.067ZM6.27009 2.87209C6.49435 2.61043 7.17981 2.31271 7.17981 2.31271C7.17981 2.31271 8.1321 2.69858 8.77756 3.47307C9.44458 4.27445 9.80476 5.46445 9.80476 5.46445C9.80476 5.46445 9.6396 5.81021 9.35467 5.95286C9.04454 6.10961 8.61168 6.06362 8.61168 6.06362L6.18629 3.47192C6.18629 3.47192 6.00185 3.18813 6.27009 2.87209ZM22.1788 20.6785C22.0794 20.9293 21.5954 21.0439 21.5954 21.0439C21.5954 21.0439 20.3565 20.8793 19.5985 20.2789C18.7408 19.6051 18.3506 18.4839 18.3506 18.4839C18.3506 18.4839 18.336 18.005 18.6437 17.6919C19.1289 17.1962 19.9511 17.4154 20.9648 18.3388C21.6648 18.9792 21.9948 20.03 21.9948 20.03C21.9948 20.03 22.2809 20.4248 22.1788 20.6785Z"
				fill="white" />
		</g>
		<defs>
			<clipPath id="clip0_3654_44570">
				<rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
			</clipPath>
		</defs>
	</svg>
</template>

<script>
export default {
	name: 'phone-visit',
	props: {
		width: {
			type: String,
			default: '24px'
		}
	},
	data() {
		return {
			style: {
				width: this.width,
				'vertical-align': 'middle',
				fill: 'currentColor',
				overflow: 'hidden',
			}
		}
	}
}
</script>